import { useEffect, useState } from 'react';

// Tracks an in-progress typed value separately from the committed value bound to an input's
// `value` prop, so useCommitOnEvents' commit-on-blur comparison isn't short-circuited by
// echoing the live value back as the "committed" baseline.
export const useLiveDraft = <T>(committed: T): [T, (value: T) => void] => {
  const [live, setLive] = useState(committed);
  useEffect(() => {
    setLive(committed);
  }, [committed]);
  return [live, setLive];
};
